import { render, staticRenderFns } from "./FiltersCheckboxes.vue?vue&type=template&id=621393cc"
import script from "./FiltersCheckboxes.vue?vue&type=script&lang=ts"
export * from "./FiltersCheckboxes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports